import { render, staticRenderFns } from "./IntegrationCasinos.vue?vue&type=template&id=81a41b30&scoped=true&"
import script from "./IntegrationCasinos.vue?vue&type=script&lang=js&"
export * from "./IntegrationCasinos.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationCasinos.vue?vue&type=style&index=0&id=81a41b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a41b30",
  null
  
)

export default component.exports